"use strict";
(function (global) {
    //deklaracja klasy
    class SimpleDataSource {
        constructor(config) {
            /**
             * Adres dostępowy do danych
             */
            this.baseUrl = null;
            /**
             * Adres na który będą wysyłane zapytania do aktualizacji.
             *
             * @type String
             */
            this.updateUrl = null;
            /**
             * Podstawowe parametry przekazywane razem z każdym requestem.
             *
             * @type Object
             */
            this.baseParameters = {};

            this.filterValues = [];
            this.sortValues = {
                "order": null,
                "dataIndex": null
            };

            this.init(config);
        }

        init(config) {
            this.baseUrl = config.url ? config.url : null;
            this.baseParameters = config.baseParameters ? config.baseParameters : {};
            this.updateUrl = config.updateUrl ? config.updateUrl : config.url;
        }

        prepareBaseParametersQueryString = function() {
            const queryString = [];

            for (let key in this.baseParameters) {
                if (!this.baseParameters.hasOwnProperty(key)) {
                    continue;
                }

                const value = this.baseParameters[key];

                if (value instanceof Array) {
                    let subIndex = 0;
                    const subLen = value.length;
                    for (; subIndex < subLen; subIndex++) {
                        queryString.push(key + "[]=" + value[subIndex]);
                    }
                }
                else {
                    queryString.push(key + "=" + value);
                }
            }

            return queryString;
        }

        filterBy(values) {
            this.filterValues = values;
        }

        orderBy(dataIndex, direction) {
            this.sortValues.dataIndex = dataIndex;
            this.sortValues.order = direction;
        }

        getOrderBy() {
            return this.sortValues;
        }

        getUpdateUrl() {
            let retVal = null;

            if (this.updateUrl !== null) {
                const baseQueryString = this.prepareBaseParametersQueryString();

                retVal = this.updateUrl + (this.updateUrl.indexOf("?") > -1 ? "&": "?") + baseQueryString.join("&");
            }

            return retVal;
        }

        changeParameterValue(key, value) {
            this.baseParameters[key] = value;
        };

        prepareUrl() {
            const url = this.baseUrl;
            let queryString;

            queryString = this.filterValues.map(function (filterValue) {
                return "filters[" + filterValue.dataIndex + "]=" + encodeURIComponent(filterValue.value);
            });

            queryString = queryString.concat(this.prepareBaseParametersQueryString());

            if (this.sortValues.dataIndex && this.sortValues.order) {
                queryString.push("sort[order]=" + encodeURIComponent(this.sortValues.order));
                queryString.push("sort[key]=" + encodeURIComponent(this.sortValues.dataIndex));
            }

            return url + (url.indexOf("?") > -1 ? "&" : "?") + (queryString.length > 0 ? queryString.join("&") : '');
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Grid = global.NS.Grid || {};
    global.NS.Grid.SimpleDataSource = SimpleDataSource;
})(window);
